import { TextField, withStyles } from "@material-ui/core";
import { useStyles } from "@material-ui/pickers/views/Calendar/SlideTransition";
import React from "react";

const ValidationTextFieldValue = withStyles({
  root: {
    "& input:valid + fieldset": {
      borderColor: "green",
      borderWidth: 2,
    },
    "& input:invalid + fieldset": {
      borderColor: "",
      borderWidth: 2,
    },
    "& input:valid:focus + fieldset": {
      borderLeftWidth: 6,
      padding: "4px !important", // override inline-style
    },
  },
})(TextField);

function ValidationTextField({
  value,
  id,
  type,
  onChange,
  placeholder,
  helperText,
  name,
  error,
  disabled

}) {
  const classes = useStyles();
  return (
    <div>
      <ValidationTextFieldValue
        className={classes.margin}
        required
        value={value}
        name={name}
        placeholder={placeholder}
        type={type}
        onChange={onChange}
        variant="outlined"
        id={id}
        helperText={helperText}
        error={error}
        disabled={disabled?disabled:false}
        
      />
    </div>
  );
}

export default ValidationTextField;
